import React, { useEffect, useState } from "react";
import { getPage } from 'services/api/Shop';

const Faq = () => {
  const [data, setData] = useState(""); 

  useEffect(() => {
    getPage(142).then((data) => {
      setData(data?.content?.content)
    });
  }, []);

  return (
    <div className="container">
      <div dangerouslySetInnerHTML={{__html: data}} />
    </div>
  )
}

export default Faq;